<template>
  <div class="position-relative" tabindex="1" @focusout="verifyIfChildAndClose">
    <div>
      <div class="filter-label"><span class="title">
          <slot>
            {{ label }}
          </slot>
        </span>
        <span @click="isDropdownOpen = !isDropdownOpen" class="d-flex align-items-center justify-content-between w-100">
          <span>{{ formattedSelected() }}</span> <i class="las la-angle-down la-xs icon-color"></i>
        </span>
      </div>
    </div>
    <div
      v-if="isDropdownOpen"
      :class="['menu-list content-container', disabled ? 'pointer-none' : '']"
    >
      <base-input type="no-label" :remove_default_margin="true" ref="searchinp" cus_ref="ipsearch"
        :value.sync="searchOps" @change-value="handleSearch">
        <!-- Needs additional styling $isMobile() ? 'badge' : '', -->
      </base-input>
      <div class="d-flex justify-content-center clear-menu menu-item" v-if="this.allLabel !== ''"
      @mouseenter="addClass"
      @mouseleave="removeClass"
       @click="resetChoices" >
        <base-button
            cus_style="margin: 1px 1px 1px 1px"
            stylevariant="hardlink"
        >{{ allLabel }}
        </base-button>
      </div>
      <div
        ref="optionsScrollContainer"
        class="menu-list-options"
        :style="scrollOptionsStyle"
        @scroll="onOptionsScroll"
      >
        <div
          v-for="(menu_item) in filteredOptions()"
          :class="[
            'menu-item d-flex',
          ]"
          :key=menu_item.id
          @mouseenter="addClass"
          @mouseleave="removeClass"
        >
          <template v-if="multiple">
            <b-form-checkbox :class="['mb-2 justify-left']"
            :checked="handlechecked(menu_item)"
            @input="evt => handleUpdate(menu_item, evt)"
            >
            &nbsp;&nbsp;&nbsp;{{ menu_item.name }}</b-form-checkbox>
            <div v-if="sideSingle" class="singleselect" @click="evt=>handleSingleSelect(menu_item, evt, 'single')"> </div>
          </template>
          <template v-else>
            <div :class="['mb-2 mt-1 ps-1 singleselect p-l-1']"  @click="evt=>handleSingleSelect(menu_item, evt, 'single')" >
              &nbsp;&nbsp;&nbsp;{{ menu_item.name }}</div>
          </template>
        </div>
        <div v-if="searchResultsLoading" class="d-flex justify-content-center py-2 menu-item">
          <b-spinner small class="align-middle"></b-spinner>
          <span class="ml-2 small">Searching...</span>
        </div>
        <div v-if="hasMore && loadingMore && !(searchOps && searchOps.trim())" class="d-flex justify-content-center py-2 menu-item">
          <b-spinner small class="align-middle"></b-spinner>
          <span class="ml-2 small">Loading more...</span>
        </div>
      </div>
      <div class="d-flex justify-content-center clear-menu menu-item" @mouseenter="addClass" @mouseleave="removeClass" v-if="this.allLabel !== ''"
        @click="resetChoices">
        <base-button cus_style="margin: 1px 1px 1px 1px" stylevariant="hardlink">Clear all
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from './UI/BaseButton.vue';
import BaseInput from './UI/BaseInput.vue';
export default {

  name: "MultiselectDropdown",
  components:{BaseButton, BaseInput},
  props:  {
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
      multiple: {
        type: Boolean,
        default() {
          return false;
        },
      },
      sideSingle:{
        type: Boolean,
        default() {
          return false;
        },
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
      placeholder: {
        type: String,
        default() {
          return `Select ${
            this.multiple ? "multiple merchants" : "merchant"
          }`;
        },
      },
      value: {
        type: Object | Array,
        default() {
          return {};
        },
      },
      label: {
        type: String,
        default() {
          return "";
        },
      },
      allLabel:{
        type: String,
        default() {
          return "";
        },
      },
      elementlable:{
        type: String,
        default() {
          return "";
        },
      },
      reduce: {
        type: Function,
        default: (option) => option,
      },
      filters: {
        type: Object,
        default() {
          return {};
        },
      },
      default: {
        type: Boolean,
        default() {
          return false;
        },
      },
      selectedName:{
        type: String,
        default() {
          return '';
        },
      },
      hasMore: {
        type: Boolean,
        default: false,
      },
      loadingMore: {
        type: Boolean,
        default: false,
      },
      /** When provided, search uses these results (from API) instead of filtering options client-side */
      searchResults: {
        type: Array,
        default: null,
      },
      searchResultsLoading: {
        type: Boolean,
        default: false,
      },
      searchDebounceMs: {
        type: Number,
        default: 300,
      },
    },
    components: {
      BaseInput,
      BaseButton
    },
    mounted(){
      if(this.selectedName){
        this.formattedSelected()
      }
      if(this.options?.length && this.value?.length){
        this.shouldEmit = false;
        let selectedOption =[]
        for(let item of this.value){
          let selecteditem = this.options.filter((itm) => itm.id == item);
          selectedOption.push(selecteditem[0]);
          this.handlechecked(selecteditem[0]);
        }
        this.selected = selectedOption;
      }
    },
  methods: {
    resetChoices() {
      this.selected = []
      this.searchOps = '';
      this.$emit("item-select", null);
      this.isDropdownOpen = false;
    },
    handleUpdate(menu_item, update) {
      if (update) {
        let checkifExists = this.selected.find((itm) => itm.id === menu_item.id) !== undefined
        if (!checkifExists) {
          let selectedItems = [...this.selected, menu_item]
          this.selected = selectedItems;
        }
      }
      else {
        let selectedItems = this.selected.filter(itm => itm.id !== menu_item.id);
        this.selected = selectedItems;
      }
    },
    handleSingleSelect(menu_item, event, type) {
      if (event.type == 'click') {
        this.selected = [menu_item];
      }
    },
    handlechecked(menu_item, evt) {
      if (this.selected.length > 0) {
        let selectedArr = this.selected.map((itm) => itm.id)
        if (selectedArr.includes(menu_item.id)) {
          return true
        }
        return false
      }
      else {
        return false
      }

    },
    handleSearch(event, field) {
      this.searchOps = event
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
        this.searchDebounceTimer = null
      }
      if (this.searchResults !== null) {
        if (!this.searchOps || !this.searchOps.trim()) {
          this.$emit('search-input', '')
        } else {
          this.searchDebounceTimer = setTimeout(() => {
            this.$emit('search-input', this.searchOps.trim())
            this.searchDebounceTimer = null
          }, this.searchDebounceMs)
        }
      }
    },
    verifyIfChildAndClose(evt) {
      if (evt.relatedTarget) {
        if (evt.srcElement.contains(evt.relatedTarget)) { // If clicked on input field within
          return;
        }
        return;
      }
      this.isDropdownOpen = false;
    },
    formattedSelected() {
      if(this.selectedName.length){
        return `${this.selectedName}`;
      }
      if (this.selected.length === 0) {
        return  `${this.allLabel}`;
      }
      else {
        return `${this.selected[0].name}${this.selected.length > 1 ? " +" + (this.selected.length - 1) : ""}`;
      }
    },
    filteredOptions() {
      const term = (this.searchOps || '').trim();
      if (term && Array.isArray(this.searchResults)) {
        return this.searchResults;
      }
      if (term) {
        return this.options.filter(key => key.name && key.name.toLocaleLowerCase().includes(term));
      }
      return this.options;
    },
    addClass: function (e) {
      if (e.target.classList.contains("menu-item")) {
        e.target.classList.add("hovered");
      }
    },
    removeClass: function (e) {
      if (e.target.classList.contains("menu-item")) {
        e.target.classList.remove("hovered");
      }
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.searchinp.$refs.ipsearch.focus();
      });
    },
    onOptionsScroll() {
      if (!this.hasMore || this.loadingMore) return;
      const el = this.$refs.optionsScrollContainer;
      if (!el) return;
      const { scrollTop, scrollHeight, clientHeight } = el;
      const threshold = 80;
      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        this.$emit('load-more');
      }
    },
    /* Force scroll container to show scrollbar on first open (analytics/monthlynumbers) */
    forceScrollContainerReflow() {
      const runReflow = () => {
        const el = this.$refs.optionsScrollContainer;
        if (!el) return;
        /* Force fixed height and overflow so scrollbar always appears */
        el.style.height = '320px';
        el.style.minHeight = '320px';
        el.style.overflowY = 'scroll';
        el.style.overflowX = 'hidden';
        /* Trigger reflow */
        const prev = el.style.overflowY;
        el.style.overflowY = 'hidden';
        void el.offsetHeight;
        el.style.overflowY = prev || 'scroll';
      };
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(runReflow);
        });
      });
      setTimeout(runReflow, 100);
      setTimeout(runReflow, 300);
    },
  },
  watch: {
    isDropdownOpen(newVal) {
      this.focusInput();
      if (!newVal) {
        this.searchOps = "";
        if (this.searchResults !== null) this.$emit('search-input', '');
      } else {
        /* Wait for paint (double rAF) so scrollbar appears on analytics/monthlynumbers after reload */
        this.forceScrollContainerReflow();
      }
    },
    options() {
      if (this.isDropdownOpen) {
        this.forceScrollContainerReflow();
      }
    },
    multiple(val){
      if (val == false){
        this.selected = this.options[0];
      }
    },
    default(val){
      if(val){
        this.selected = this.options[0];
      }
    },
    selected(newVal, oldval) {
      if(newVal && oldval){
        let newValIds = newVal.map(obj => obj.id).toString();
        let oldvalIds = oldval.map(obj => obj.id).toString();
        if (newValIds !== oldvalIds && this.shouldEmit == true) {
          this.$emit("item-select", newVal);
        }
      }
    },
  },
  computed: {
    /* Fixed pixel height so scrollbar appears on first open (vh can be wrong on analytics/monthlynumbers) */
    scrollOptionsStyle() {
      return {
        height: '320px',
        minHeight: '320px',
        overflowY: 'scroll',
        overflowX: 'hidden',
      };
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      searchOps: '',
      selected: [],
      shouldEmit: true,
      searchDebounceTimer: null,
    }
  },
  beforeDestroy() {
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
  },

};
</script>
<style scoped lang="scss">
.content-container {
  @include content-container;
}

.pointer-none {
  pointer-events: none;
  cursor: not-allowed;
}

.menu-list {
  position: absolute;
  width: 90%;
  top: 3rem;
  left: 0px;
  z-index: 99999;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  direction: ltr;
}

/* Height/overflow set via :style (scrollOptionsStyle) so scrollbar shows on first load */
.menu-list-options {
  flex: 0 0 auto;
  -webkit-overflow-scrolling: touch;
  direction: ltr;
}
.clear-menu{
  padding:5px;
  border-top:outset;
}

.title {
  @extend %title;
  color: #777777;
  font-size: 12px;
  position: absolute;
  bottom: 30px;
  left: 1rem;
}

.filter-label {
  min-width: 6rem;
  color: #111111;
  font-size: 15px;
  font-family: $brand-font-medium;
  cursor: pointer;
  border: 1px solid #edece9;
  padding: 0.45rem 0.5rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

@media (max-width: 991.98px) {
  .filter-label {
    padding: 0.3rem 0.5rem;
  }
}

.icon-color {
  color: #777777;
}

.justify-left {
  justify-content: left !important;
  padding-left: 2rem;
}

.hovered {
  background-color: #efeeed !important;
}

::v-deep label.custom-control-label {
  width: max-content !important
}

.singleselect {
  width: -webkit-fill-available;
  padding-left:1rem;
}
</style>